import React from 'react'
import { useTheme } from 'styled-components'

export const CommonStyles = () => {
  const theme = useTheme()
  const primaryColor = theme?.forecast?.text1 || '#ffffff'
  const secondaryColor = theme?.forecast?.background1 || '#ffffff'

  return (
    <svg>
      <linearGradient id='white-gray-gradient-horizontal'>
        <stop
          id='v-25'
          offset='0%'
          stopColor={primaryColor}
          stopOpacity='1'></stop>
        <stop
          id='v-26'
          offset='30%'
          stopColor={secondaryColor}
          stopOpacity='1'></stop>
        <stop
          id='v-27'
          offset='70%'
          stopColor={secondaryColor}
          stopOpacity='1'></stop>
        <stop
          id='v-28'
          offset='100%'
          stopColor={primaryColor}
          stopOpacity='1'></stop>
      </linearGradient>
      <linearGradient
        id='white-gray-gradient-vertical'
        x1='0%'
        y1='0%'
        x2='0%'
        y2='100%'>
        <stop
          id='v-51'
          offset='0%'
          stopColor={primaryColor}
          stopOpacity='1'></stop>
        <stop
          id='v-52'
          offset='30%'
          stopColor={secondaryColor}
          stopOpacity='1'></stop>
        <stop
          id='v-53'
          offset='70%'
          stopColor={secondaryColor}
          stopOpacity='1'></stop>
        <stop
          id='v-54'
          offset='100%'
          stopColor={primaryColor}
          stopOpacity='1'></stop>
      </linearGradient>
    </svg>
  )
}
